import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  type BillsUnpaidSummaryResponse,
  type BillUnpaidSummary,
} from '@webapp/models/BillUnpaidSummary'
import { CurrencyName } from '@webapp/models/enums'

export const BillUnpaidSummaryMock =
  Factory.Sync.makeFactory<BillUnpaidSummary>({
    count_of_unpaid_bills: Factory.each(() =>
      faker.random.number(20).toString()
    ),
    unpaid_bills_total_amount: Factory.each(() =>
      faker.random.number(20000).toString()
    ),
    currency: CurrencyName.CAD,
  })

export const BillsUnpaidSummaryResponseMock =
  Factory.Sync.makeFactory<BillsUnpaidSummaryResponse>({
    summaries: [BillUnpaidSummaryMock.build()],
  })
